import React, { Component } from 'react';
class FullWidth extends Component {
    render() { 
        const{SectionClass} =this.props;
        return ( 
            <section className={SectionClass?SectionClass:''}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </section>
         );
    }
}
 
export default FullWidth;